export class LibConfiguration {
  apiUrl: string;
  companyName: string;
  routes: {
    example: boolean;
    path: string;
    title: string;
    type: string;
    icontype: string;
  }[];
  showPartnerAndProject: boolean;
}
